export default __webpack_public_path__ + "59ea65072b16cf4ea62e22ddf41d1b9d.png";